import React from 'react';
import { FormHelperText } from '@chakra-ui/react';
import IconButton from '../IconButton/component.js';
import { Typography } from '../Typography/component.js';

var OptionLabel = function OptionLabel(_ref) {
  var label = _ref.label,
      helpText = _ref.helpText,
      tooltip = _ref.tooltip,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    textAlign: "center"
  }, label, tooltip && /*#__PURE__*/React.createElement(IconButton, {
    icon: {
      iconName: 'info-circle',
      prefix: 'far'
    },
    isRound: true,
    minH: 'auto',
    minW: 'auto',
    w: 'auto',
    h: 'auto',
    ml: 'xs',
    tooltip: {
      content: tooltip.content,
      placement: 'top'
    },
    verticalAlign: 'baseline',
    variant: "ghost",
    colorScheme: "info"
  })), helpText && /*#__PURE__*/React.createElement(FormHelperText, {
    fontSize: "sm"
  }, helpText), children);
};

OptionLabel.displayName = 'OptionLabel';
export { OptionLabel };